module.exports = __webpack_public_path__ + "img/video.50fe6b87.png";